<template>
  <BaseAction>
    <NewTalentPoolDialog
      @close="closeDialog"
      @onSuccess="closeDialog"
      v-if="isOpen"
    />
    <SecondaryButton @click.native="openDialog" color="primary">
      <div class="d-flex align-center justify-center">
        <v-img height="15px" contain src="@/assets/svg/pool_icon_white.svg" />
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Talent Pool
    </SecondaryButton>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewTalentPoolDialog from "@/views/workers/TalentPools/dialogs/NewTalentPoolDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "NewTalentPoolAction",
  components: {
    SecondaryButton,
    NewTalentPoolDialog,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
